import React from 'react';
import	{useNavigate} from 'react-router-dom';
import Fab from '@mui/material/Fab';
import AddIcon from '@mui/icons-material/Add';

export default function Meow() {
	let navigate = useNavigate();
	
	return(
		<>
				<Fab size="large" color="secondary" aria-label="add" onClick={() => { navigate('/postcreateform') }} sx={{  position: 'fixed', bottom: 70,  right: 20, zIndex: 10}} >
					<AddIcon />
				</Fab>
		</>
	);
}